module.exports = __webpack_public_path__ + "components/country-flag/static/bf-c3e6d9cd907ce21af9e1d82dc17ed355.svg";